// Vending audio host preferences — versioned device-local snapshot.
// Host is the only writer; preferences never contain account/runtime identity.
// Corrupt/unknown version → valid defaults; storage exception → session-only preference.

export const PREFERENCE_DEFAULTS = Object.freeze({
  version: 1,
  enabled: true,
  music: 1,
  ambience: 1,
  sfx: 1,
})

function clamp01(value) {
  if (typeof value !== "number" || !Number.isFinite(value)) return null
  if (value < 0 || value > 1) return null
  return value
}

export function isValidPreference(value) {
  return (
    value !== null &&
    typeof value === "object" &&
    value.version === 1 &&
    typeof value.enabled === "boolean" &&
    clamp01(value.music) !== null &&
    clamp01(value.ambience) !== null &&
    clamp01(value.sfx) !== null
  )
}

export function normalizePreference(value) {
  if (!isValidPreference(value)) return null
  return {
    version: 1,
    enabled: value.enabled,
    music: clamp01(value.music),
    ambience: clamp01(value.ambience),
    sfx: clamp01(value.sfx),
  }
}

export function defaultPreference() {
  return { ...PREFERENCE_DEFAULTS }
}

// Apply preference state to an immutable snapshot; returns normalized object.
export function applyPreference(current, next) {
  const normalized = normalizePreference(next)
  if (!normalized) return current
  return normalized
}
